<template>
  <span
    ref="ipsTip"
    data-bs-toggle="tooltip"
    :title="tooltip"
    data-bs-container="body"
    class="ips-tooltip"
  >
    <slot name="tip" :hide="hide" :toggle="toggleEnabled" :destroy="destroy"></slot>
  </span>
</template>

<script>
import { Tooltip } from 'bootstrap';

export default {
  name: 'IpsTooltip',
  props: {
    tooltip: {
      name: 'tooltip',
      description: 'The tooltip',
      type: String,
      required: true,
    },
    placement: {
      name: 'tooltipPlacement',
      description: 'Set tooltip display location',
      type: String,
      default: 'auto',
      required: false,
      validator: (value) => ['auto', 'top', 'left', 'bottom', 'right'].indexOf(value) !== -1,
    },
    html: {
      name: 'html',
      description: 'Tip contains html',
      type: Boolean,
      default: false,
      required: false,
    },
    entryDelay: {
      name: 'entryDelay',
      description: 'Set a delay on entry',
      type: Number,
      default: 0,
      required: false,
    },
    exitDelay: {
      name: 'exitDelay',
      description: 'Set a delay on exit',
      type: Number,
      default: 0,
      required: false,
    },
    trigger: {
      name: 'trigger',
      description: 'How tooltip is triggered',
      type: String,
      default: 'hover focus',
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    config() {
      // todo: Add sanitize function to protect against injection attack
      return {
        boundary: 'scrollParent',
        customClass: 'ips-tooltip',
        trigger: this.trigger,
        placement: this.placement,
        html: this.html,
        sanitize: !this.html,
        delay: { show: this.entryDelay, hide: this.exitDelay },
      };
    },
  },
  created() {
    this.$nextTick(() => {
      this.start();
    });
  },
  updated() {
    this.$nextTick(() => {
      Tooltip.getInstance(this.$refs.ipsTip).dispose();
      this.start();
    });
  },
  methods: {
    start() {
      new Tooltip(this.$refs.ipsTip, this.config);
    },
    hide() {
      Tooltip.getInstance(this.$refs.ipsTip).hide();
    },
    toggleEnabled() {
      Tooltip.getInstance(this.$refs.ipsTip).toggleEnabled();
    },
    destroy() {
      Tooltip.getInstance(this.$refs.ipsTip).dispose();
    },
  },
};
</script>

<style lang="scss">
@import 'IpsTooltip';
</style>
